import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeResourceUrl, SafeHtml } from '@angular/platform-browser';
import { CoreService, QueovalDateService } from '../services';
import { QueovalDate, ConfigKey, LearnerDetail } from '../models';
import { isEmptyStr } from '../utilities';
import { Observable } from 'rxjs';
import { of } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

// #region PIPE TRADUCTION
@Pipe({
  name: 'trad'
})
export class TraductionPipe implements PipeTransform {

  constructor(
    protected indparam: CoreService
  ) { }

  transform(key: string, ...args: string[]): string {
    if (key === undefined) {
      return 'notrad';
    } else {
      const vl: string = this.indparam.getTrad(key, ...args);
      if (vl) {
        return vl;
      } else {
        return `[${key}]`;
      }
    }
  }
}

@Pipe({
  name: 'tradAsync'
})
export class TraductionPipeAsync implements PipeTransform {

  constructor(
    protected indParam: CoreService
  ) { }

  transform(key: string, ...args: string[]): Observable<string> {
    return this.indParam.traductionSubject$.pipe(
      mergeMap((value: boolean) => {
        if (key === undefined) {
          return of('notrad');
        } else {
          const vl: string = this.indParam.getTrad(key, ...args);
          if (vl) {
            return of(vl);
          } else {
            return of(`[${key}]`);
          }
        }
      }));
  }
}
// #endregion

// #region PIPE IMAGES
@Pipe({
  name: 'getimage'
})
export class ImagePipe implements PipeTransform {

  constructor(
    protected indparam: CoreService
  ) { }

  transform(image: string, folder: string): string {
    const link: string = `${this.indparam.getConfigKey(ConfigKey.IMGHTTP)}images/${folder}/${image}`;
    return link;
  }
}
// #endregion

// #region PIPE CUTTEXT
@Pipe({
  name: 'cuttext'
})
export class CutTextPipe implements PipeTransform {

  constructor(
  ) { }

  transform(value: string, caracterNumber: number, end: string = ''): string {
    let text: string = '';
    if (value.length >= caracterNumber) {
      text = value.substring(0, caracterNumber);
      value = `${text}${end}`;
    }
    return value;
  }
}
// #endregion

// #region PIPE CUSTOMDATE
@Pipe({
  name: 'customdate'
})
export class CustomDatePipe implements PipeTransform {

  constructor(
    protected indparam: CoreService
  ) { }

  transform(value: string): string {
    if (value === '' || value === undefined || value === null) {
      return '';
    } else {
      const date: Array<string> = value.split('/');
      const year: string = date[2];
      const month: string = date[1];
      const day: string = date[0];

      if (year === '0000' && month === '00' && day === '00') {
        return '';
      } else {

        if (this.indparam.AppParams.culture === 'fr-FR') {
          return `${day}/${month}/${year}`;
        } else if (this.indparam.AppParams.culture === 'en-GB') {
          return `${year}/${month}/${day}`;
        } else {
          return `${day}/${month}/${year}`;
        }
      }
    }
  }
}
// #endregion



@Pipe({
  name: 'qDate'
})
export class QDatePipe implements PipeTransform {

  constructor(
    protected indParam: CoreService,
    protected qDateService: QueovalDateService,
  ) { }

  transform(value: QueovalDate): string {
    if (this.qDateService.IsNull(value)) {
      return '';
    }
    const date: Date = this.qDateService.ToDate(value)!;
    return new Intl.DateTimeFormat(this.indParam.AppParams.culture).format(date);
  }
}

@Pipe({
  name: 'secondToHour'
})
export class SecondToHour implements PipeTransform {

  transform(value: string | number): number {
    if (typeof (value) == 'string') {
      let val = parseInt(value);
      return val != undefined ? val / 3600 : 0;
    } else {
      return value / 3600;
    }
  }
}


// #region PIPE Date day
// pipe pour récupérer le jour (lundi, mardi, mercredi,...) par queovaldate
@Pipe({
  name: 'DayOfQueovalDate'
})
export class DayOfQueovalDatePipe implements PipeTransform {

  constructor() { }

  transform(value: QueovalDate, culture: string, format: string, increment: number = 0): string {
    const date: Date = new Date(Number.parseInt(value.annee), Number.parseInt(value.mois) - 1, Number.parseInt(value.jour) + increment);
    const options = { weekday: format };
    return date.getFullYear() > 1900 ? new Intl.DateTimeFormat(culture, (options as any)).format(date).replace('.', '') : '';
  }
}


@Pipe({
  name: 'MonthOfQueovalDate'
})
export class MonthOfQueovalDatePipe implements PipeTransform {

  constructor() { }

  transform(value: QueovalDate, culture: string, format: string, increment: number = 0): string {
    const date: Date = new Date(Number.parseInt(value.annee), Number.parseInt(value.mois) - 1, Number.parseInt(value.jour));
    date.setDate(date.getDate() + increment);
    const options = { month: format };
    return date.getFullYear() > 1900 ? new Intl.DateTimeFormat(culture, (options as any)).format(date) : '';
  }
}

@Pipe({
  name: 'NumberOfQueovalDay'
})
export class NumberOfQueovalDayPipe implements PipeTransform {

  constructor() { }

  transform(value: QueovalDate, increment: number = 0): string {
    const date: Date = new Date(Number.parseInt(value.annee), Number.parseInt(value.mois) - 1, Number.parseInt(value.jour));
    date.setDate(date.getDate() + increment);
    return date.getFullYear() > 1900 ? date.getDate().toString() : '';
  }
}

@Pipe({
  name: 'NumberOfQueovalYear'
})
export class NumberOfQueovalYearPipe implements PipeTransform {

  constructor() { }

  transform(value: QueovalDate, increment: number = 0): string {
    const date: Date = new Date(Number.parseInt(value.annee), Number.parseInt(value.mois) - 1, Number.parseInt(value.jour) + increment);
    return date.getFullYear() > 1900 ? date.getFullYear().toString() : '';
  }
}


// #region PIPE GETHOUR
//@Pipe({
//  name: 'hour'
//})
//export class HourPipe implements PipeTransform {

//  constructor(
//    protected indparam: CoreService
//  ) { }

//  transform(value: string): string {
//    let maDate: QueovalDate = new QueovalDate();
//    maDate = JSON.parse(value);
//    return maDate.hour;

//  }
//}
// #endregion

// #region PIPE HOUR/MINUTE
// pipe pour traduire des minutes en heures/minutes au format 00h00
@Pipe({
  name: 'hourMinute'
})
export class HourMinutePipe implements PipeTransform {

  constructor() { }

  transform(value: number): string {
    const hour: number = Math.trunc(value / 60);
    const strHour: string = hour < 10 ? '0' + hour : hour.toString();
    const strMin: string = value - (hour * 60) < 10 ? '0' + (value - (hour * 60)) : (value - (hour * 60)).toString();
    return `${strHour}h${strMin}`;
  }
}
// #endregion

// #region PIPE HOUR/MINUTE/SECONDE
// pipe pour traduire des secondes en heures/minutes/secondes au format 00:00:00
@Pipe({
  name: 'hourMinuteSec'
})
export class HourMinuteSecPipe implements PipeTransform {

  constructor() { }

  transform(value: number, afficheNullHours: boolean = false): string {

    const hour: number = Math.trunc(value / 3600);
    const strHour: string = hour < 10 ? '0' + hour : hour.toString();
    const min: number = Math.trunc((value / 60) - (hour * 60));
    const strMin: string = min < 10 ? '0' + min : min.toString();
    const sec = Math.trunc(value - (min * 60) - (hour * 3600));
    const strSec: string = sec < 10 ? '0' + sec : sec.toString();
    if (afficheNullHours) {
      return `${strHour}:${strMin}:${strSec}`;
    } else {
      if (hour === 0) {
        return `${strMin}:${strSec}`
      } else {
        return `${strHour}:${strMin}:${strSec}`
      }
    }
  }
}
// #endregion


// #region PIPE TRANSFORM_FORMAT_SECOND_TO_HOUR/MINUTE
@Pipe({
  name: 'formatSecond'
})
export class FormatSecondPipe implements PipeTransform {

  constructor(
  ) { }

  transform(value: number | string): string {
    if (typeof value === 'string') {
      value = Number(value);
    }
    const h: number = Math.floor(value / 3600);
    const min: number = Math.floor(value % 3600 / 60);

    const minute: string = min < 10 ? `0${min}` : min.toString();
    const heure: string = h < 10 ? `0${h}` : h.toString();

    return `${heure}h${minute}mn`;

  }
}
// #endregion

// #region PIPE GETDAYFORCALENDAR
@Pipe({
  name: 'getDay'
})
export class GetDayPipe implements PipeTransform {

  constructor(
    protected indparam: CoreService
  ) { }

  transform(value: number): string {


    let val: string = '';
    if (this.indparam.AppParams.culture === 'fr-FR') {
      val = value === 1 ? 'Lundi' : value === 2 ? 'Mardi' : value === 3 ? 'Mercredi' :
        value === 4 ? 'Jeudi' : value === 5 ? 'Vendredi' : value === 6 ? 'Samedi' : 'Dimanche';
    }
    if (this.indparam.AppParams.culture === 'en-GB') {
      val = value === 1 ? 'Monday' : value === 2 ? 'Tuesday' : value === 3 ? 'Wednesday' :
        value === 4 ? 'Thursday' : value === 5 ? 'Friday' : value === 6 ? 'Saturday' : 'Sunday';
    }
    return val;
  }
}
// #endregion

// #region protection IFrame
@Pipe({
  name: 'safe'
})
export class SafePipe implements PipeTransform {

  constructor(private sanitizer: DomSanitizer) { }
  transform(url: string): SafeResourceUrl {

    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
// #endregion

@Pipe({ name: 'safeHtml' })
export class SafeHtmlPipe implements PipeTransform {

  constructor(private sanitizer: DomSanitizer) { }
  transform(value: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(value);
    // return this.sanitizer.bypassSecurityTrustStyle(style);
    // return this.sanitizer.bypassSecurityTrustXxx(style); - see docs
  }
}

// #region protection IFrame
@Pipe({
  name: 'showValueSeparat'
})
export class ShowValueSeparatPipe implements PipeTransform {

  transform(value: string, separator: string, index: number): string {
    if (isEmptyStr(value)) {
      return value;
    } else {
      if (!value.includes(separator)) {
        return value;
      } else {
        return value.split(separator)[index];
      }
    }
  }
}

//#endregion

@Pipe({
  name: 'grdFilter'
})
export class GrdFilterPipe implements PipeTransform {
  transform(items: any, filter: any, defaultFilter?: boolean): any {
    if (!filter) {
      return items;
    }

    if (!Array.isArray(items)) {
      return items;
    }

    if (filter && Array.isArray(items)) {
      const filterKeys: Array<string> = Object.keys(filter);

      if (defaultFilter) {
        return items.filter((item: string) =>
          filterKeys.reduce((x: boolean, keyName: any) =>
            (x && new RegExp(filter[keyName], 'gi').test(item[keyName])) || filter[keyName] === '', true));
      } else {
        return items.filter((item: string) => {
          return filterKeys.some((keyName: any) => {
            return new RegExp(filter[keyName], 'gi').test(item[keyName]) || filter[keyName] === '';
          });
        });
      }
    }
  }
}


// #region ResultQuest

@Pipe({
  name: 'learnerSort'
})
export class LearnerSortPipe implements PipeTransform {
  transform(items: LearnerDetail[], sort: string): any[] {
    let result = items;
    if (!items) {
      return [];
    }

    switch (sort) {
      case 'name':
        result = result.sort((a, b) => {
          if (a.name < b.name) { return -1; }
          if (a.name > b.name) { return 1; }
          return 0;
        });
        break;
      case 'id':
        result = result.sort((a, b) => {
          const id1 = (parseInt(a.ident, 10) || 0);
          const id2 = (parseInt(b.ident, 10) || 0);
          return id2 - id1;
        });
        break;
      case 'mark':
        result = result.sort((a, b) => {
          const note1 = (a.note || 0);
          const note2 = (b.note || 0);
          return note2 - note1;
        });
        break;
      default:
        break;
    }


    return result;

  }
}

// #endregion




/**
 * Pipe permettant de "stringifier" un objet en JSON (pour pouvoir le passer en value d'un select)
 */
@Pipe({ name: 'stringify' })
export class StringifyPipe implements PipeTransform {
  /**
   * Transformation d'un objet en JSON
   * @param value Objet à transformer
   */
  transform(value: any): string {
    if (typeof (value) === 'string') {
      return value;
    } else {
      return JSON.stringify(value);
    }
  }
}



/**
 * Pipe permettant de construire un string monétaire 
 */
@Pipe({ name: 'money' })
export class MoneyPipe implements PipeTransform {
  constructor(
    protected indParam: CoreService
  ) { }

  transform(value: any): string {
    let devise: string;
    switch (this.indParam.AppParams.Devise) {
      case '€': devise = 'EUR'; break;
      case '$': devise = 'USD'; break;
      case '£': devise = 'GBP'; break;
      default: devise = this.indParam.AppParams.Devise; break;
    }

    return new Intl.NumberFormat(this.indParam.AppParams.culture, { style: 'currency', currency: devise }).format(value ? value : 0);

  }
}
